import largeThumbs$ from './largeThumbs';
import watermarkFilter from '../../watermarkFilter';
import createServiceObservables from './createServiceObservable';

const observables = createServiceObservables(
    'watermark',
    largeThumbs$,
    async (largeThumb) => ({
        ...largeThumb,
        watermarked: largeThumb.params.watermark.enabled ?
            new File(
                [ new Blob([ await watermarkFilter.generate(
                    new Uint8Array(await largeThumb.largeThumb.arrayBuffer()),
                    largeThumb.params.watermark.image || null,
                    {
                        opacity: largeThumb.params.watermark.opacity!,
                        size: largeThumb.params.watermark.size!,
                        spacing: largeThumb.params.watermark.spacing!,
                        antiAiLevel: largeThumb.params.watermark.antiAiLevel,
                    },
                    largeThumb.photo.signal,
                ) ]) ],
                largeThumb.params.filename
             ) : largeThumb.largeThumb,
    }),
);
const watermarkErrors$ = observables.errorsOnly$;
const watermark$ = observables.withoutErrors$;

export { watermarkErrors$ };
export default watermark$;
